/**
 * Inventory Lists Service
 * @see US-39.3
 */

import { apiClient } from '@/api/client';
import type {
  InventoryList,
  InventoryListWithItems,
  CreateInventoryListDto,
  UpdateInventoryListDto,
  UpdateInventoryListItemsDto,
  ApiSuccess,
} from '@bstock/shared';

export const inventoryListsService = {
  async getAll(): Promise<InventoryList[]> {
    const response = await apiClient.get<ApiSuccess<InventoryList[]>>('/inventory-lists');
    return response.data.data;
  },

  async getActive(): Promise<InventoryList[]> {
    const response = await apiClient.get<ApiSuccess<InventoryList[]>>('/inventory-lists/active');
    return response.data.data;
  },

  async getById(id: string): Promise<InventoryListWithItems> {
    const response = await apiClient.get<ApiSuccess<InventoryListWithItems>>(`/inventory-lists/${id}`);
    return response.data.data;
  },

  async create(data: CreateInventoryListDto): Promise<InventoryListWithItems> {
    const response = await apiClient.post<ApiSuccess<InventoryListWithItems>>('/inventory-lists', data);
    return response.data.data;
  },

  async update(id: string, data: UpdateInventoryListDto): Promise<InventoryList> {
    const response = await apiClient.patch<ApiSuccess<InventoryList>>(`/inventory-lists/${id}`, data);
    return response.data.data;
  },

  async replaceItems(id: string, data: UpdateInventoryListItemsDto): Promise<InventoryListWithItems> {
    const response = await apiClient.put<ApiSuccess<InventoryListWithItems>>(`/inventory-lists/${id}/items`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/inventory-lists/${id}`);
  },
};
